import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Info, Loader2 } from 'lucide-react';
import { Section } from './constantes';
import { useSuivi } from './suiviCommun';
import { ChoixSessions, Exceptions, Interrupteur } from './PilotageElements';

export const PilotageGuide = () => {
  const [cfg, setCfg] = useState(null);
  const dernier = useRef(null);
  const { data, recharger } = useSuivi();
  const appliquer = (c) => { dernier.current = c; setCfg(c); };
  useEffect(() => { axios.get('/guide-bpjeps/config').then(({ data: d }) => { dernier.current = d; setCfg(d); }).catch(() => toast.error('Impossible de charger le pilotage')); }, []);

  const maj = async (patch) => {
    const avant = dernier.current;
    const nouveau = { ...avant, ...patch };
    appliquer(nouveau);
    try {
      const { data: d } = await axios.put('/guide-bpjeps/config', nouveau);
      if (dernier.current === nouveau) appliquer(d);
      recharger();
      toast.success(d.prevenus ? `Accès mis à jour · ${d.prevenus} stagiaire${d.prevenus > 1 ? 's' : ''} prévenu${d.prevenus > 1 ? 's' : ''} par e-mail` : 'Accès mis à jour');
    } catch {
      if (dernier.current === nouveau) appliquer(avant);
      toast.error('Enregistrement impossible, réessayez.');
    }
  };

  if (!cfg || !data) return <Loader2 className="mx-auto h-6 w-6 animate-spin text-slate-400" />;
  const ouverts = data.stagiaires.filter((s) => s.acces).length;
  return (
    <div className="space-y-6" data-testid="guide-pilotage">
      <Section titre="Accès des stagiaires" sousTitre={`${ouverts} stagiaire${ouverts > 1 ? 's' : ''} sur ${data.stagiaires.length} ont accès au guide en ce moment.`} testId="guide-pilotage-stagiaires">
        <div className="space-y-4">
          <Interrupteur actif={cfg.ouvert_stagiaires} onChange={(v) => maj({ ouvert_stagiaires: v })} testId="guide-pilotage-interrupteur-stagiaires"
            titre="Guide ouvert aux stagiaires" texte="Interrupteur général : fermé, aucun stagiaire ne voit l'onglet, même avec une exception. Chaque stagiaire qui obtient l'accès est prévenu par e-mail." />
          {cfg.ouvert_stagiaires && <ChoixSessions cfg={cfg} sessions={data.sessions} maj={maj} />}
        </div>
      </Section>
      <Section titre="Équipe pédagogique" testId="guide-pilotage-equipe">
        <Interrupteur actif={cfg.ouvert_equipe} onChange={(v) => maj({ ouvert_equipe: v })} testId="guide-pilotage-interrupteur-equipe"
          titre="Ouvert aux formateurs et responsables pédagogiques" texte="Ils voient le guide et suivent la progression des stagiaires, sans rien modifier." />
      </Section>
      <Section titre="Exceptions stagiaire par stagiaire" sousTitre="Ouvrez ou fermez le guide à un stagiaire, quelle que soit sa session." testId="guide-pilotage-exceptions">
        <p className="mb-4 flex gap-2 text-xs text-slate-500"><Info className="h-4 w-4 shrink-0" /> La session d'un stagiaire est son année d'entrée en formation.</p>
        <Exceptions cfg={cfg} data={data} maj={maj} />
      </Section>
    </div>
  );
};
